const MonthInput = {
  isNativeSupported(this: any): boolean {
    if (this._nativeSupported !== undefined) return this._nativeSupported;

    const test = document.createElement("input");

    try {
      test.type = "month";
    } catch (_e) {
      // ignore
    }

    this._nativeSupported = test.type === "month";
    return this._nativeSupported;
  },

  setupElements(this: any) {
    this.monthInput = this.el.querySelector(
      "[data-month-native]",
    ) as HTMLInputElement;
    this.fallbackMonth = this.el.querySelector(
      "[data-month-fallback-month]",
    ) as HTMLSelectElement;
    this.fallbackYear = this.el.querySelector(
      "[data-month-fallback-year]",
    ) as HTMLSelectElement;
    this.fallbackContainer = this.el.querySelector(
      "[data-month-fallback]",
    ) as HTMLElement;
  },

  updateMonthInputFromFallback(this: any) {
    const month = this.fallbackMonth.value;
    const year = this.fallbackYear.value;

    if (month && year) {
      this.monthInput.value = `${year}-${month.padStart(2, "0")}`;
    } else if (month) {
      this.monthInput.value = `-${month.padStart(2, "0")}`;
    } else if (year) {
      this.monthInput.value = `${year}-`;
    } else {
      this.monthInput.value = "";
    }

    this.monthInput.dispatchEvent(new Event("input", { bubbles: true }));
  },

  applyLayout(this: any) {
    if (this.isNativeSupported()) {
      this.fallbackContainer.classList.add("hidden");
      this.fallbackMonth.removeAttribute("required");
      this.fallbackYear.removeAttribute("required");
    } else {
      this.monthInput.style.display = "none";
      this.monthInput.removeAttribute("required");
      this.fallbackContainer.classList.remove("hidden");
    }
  },

  mounted(this: any) {
    this.setupElements();
    this.applyLayout();

    if (!this.isNativeSupported()) {
      this.fallbackMonth.addEventListener("change", () =>
        this.updateMonthInputFromFallback(),
      );
      this.fallbackYear.addEventListener("change", () =>
        this.updateMonthInputFromFallback(),
      );
    }
  },

  updated(this: any) {
    this.applyLayout();
  },
};

export default MonthInput;
